var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("footer", { staticClass: "text-center" }, [
    _c("img", {
      staticClass: "logo",
      attrs: { src: require("../media/logo_untrr.png"), alt: "UNTRR" },
    }),
    _c("br"),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-sm-3" },
        [
          _c("router-link", { attrs: { to: { name: "terms" } } }, [
            _vm._v(_vm._s(_vm.$t("terms"))),
          ]),
          _c("br"),
          _c("router-link", { attrs: { to: { name: "confidentiality" } } }, [
            _vm._v(_vm._s(_vm.$t("new_account_pc"))),
          ]),
          _c("br"),
          _c("router-link", { attrs: { to: { name: "cookies" } } }, [
            _vm._v(_vm._s(_vm.$t("cookies"))),
          ]),
          _c("br"),
          _c("router-link", { attrs: { to: { name: "partners" } } }, [
            _vm._v(_vm._s(_vm.$t("partners"))),
          ]),
          _c("router-link", { attrs: { to: { name: "vignette" } } }, [
            _vm._v("ANPC"),
          ]),
          _c("br"),
          _c("router-link", { attrs: { to: { name: "info" } } }, [
            _vm._v(_vm._s(_vm.$t("info"))),
          ]),
          _c("br"),
        ],
        1
      ),
    ]),
    _c("br"),
    _c("p", {}, [_vm._v(_vm._s(_vm.$t("footer_copyright")))]),
    _vm._m(0),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v("Developed by "),
      _c("a", { attrs: { href: "https://controlf5.ro", target: "_blank" } }, [
        _c("img", {
          staticClass: "ctrlf5",
          attrs: {
            src: require("../media/logo-controlf5.png"),
            alt: "Control F5",
          },
        }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }